import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import Logo from './Logo';
import { EGRAHMANTREE_URL, NAV_LINKS, NAV_PRODUCT_LINKS } from '../config/site';

function MenuIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
      <path d="M4 7h16M4 12h16M4 17h16" strokeLinecap="round" />
    </svg>
  );
}

function ChevronDown() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="14" height="14" aria-hidden="true">
      <path d="M6 9l6 6 6-6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [productsOpen, setProductsOpen] = useState(false);

  const closeMenu = () => {
    setMenuOpen(false);
    setProductsOpen(false);
  };

  return (
    <header className="site-header">
      <div className="container site-header__inner">
        <NavLink to="/" className="brand-link" onClick={closeMenu}>
          <Logo size={44} />
        </NavLink>

        <button
          type="button"
          className="nav-toggle"
          aria-expanded={menuOpen}
          aria-controls="site-nav"
          aria-label="Toggle menu"
          onClick={() => setMenuOpen((o) => !o)}
        >
          <MenuIcon />
        </button>

        <nav id="site-nav" className={`nav${menuOpen ? ' is-open' : ''}`}>
          <NavLink to="/" end className={({ isActive }) => (isActive ? 'active' : undefined)} onClick={closeMenu}>
            Home
          </NavLink>

          <div
            className={`nav-dropdown${productsOpen ? ' is-open' : ''}`}
            onMouseEnter={() => setProductsOpen(true)}
            onMouseLeave={() => setProductsOpen(false)}
          >
            <NavLink
              to="/products"
              className={({ isActive }) => `nav-dropdown__trigger${isActive ? ' active' : ''}`}
              onClick={closeMenu}
            >
              Products <ChevronDown />
            </NavLink>
            <div className="nav-dropdown__panel">
              {NAV_PRODUCT_LINKS.map((item) => (
                <Link key={item.path} to={item.path} className="nav-dropdown__item" onClick={closeMenu}>
                  <strong>{item.label}</strong>
                  <span>{item.description}</span>
                </Link>
              ))}
              <Link to="/products" className="nav-dropdown__footer" onClick={closeMenu}>
                View all products →
              </Link>
              <a
                href={EGRAHMANTREE_URL}
                className="nav-dropdown__item nav-dropdown__item--external"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>eGrahmantree</strong>
                <span>Live home services · egrahmantree.com</span>
              </a>
            </div>
          </div>

          {NAV_LINKS.filter((l) => !['/', '/products'].includes(l.path)).map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              className={({ isActive }) => (isActive ? 'active' : undefined)}
              onClick={closeMenu}
            >
              {item.label}
            </NavLink>
          ))}

          <Link to="/demo" className="btn btn--nav nav-cta" onClick={closeMenu}>
            Request demo
          </Link>
        </nav>
      </div>
    </header>
  );
}
